/** @jsx h */

import { Fragment } from 'preact';
import { labels } from '../config';

const FilterRemoveAll = ({ resetFilters }) => {
  function handleReset() {
    resetFilters();
  }

  return (
    <Fragment>
      <div className="search__button">
        <button
          className="button button--tertiary"
          onClick={handleReset}
          type="button"
        >
          <span class="button__inner">
            <span class="button__text">{labels.faceting.removeAllFilters}</span>
            <svg class="icon icon--reset" viewBox="0 0 200 200" role="presentation">
              <use href="#icon-reset"></use>
            </svg>
          </span>
        </button>
      </div>
    </Fragment>
  );
};

export default FilterRemoveAll;
